import { jsx } from 'react/jsx-runtime';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import classNames from 'classnames';

const DraggableList = ({ children, id, disabled, items, className, ...rest })=>{
    return jsx(SortableContext, {
        disabled: disabled,
        id: id,
        items: items,
        strategy: verticalListSortingStrategy,
        children: jsx("div", {
            className: classNames('cb-draggable-list', className),
            ...rest,
            children: children
        })
    });
};
DraggableList.displayName = 'Draggable.List';

export { DraggableList };
//# sourceMappingURL=Draggable.List.es.js.map
